import { IndserObject, IndsertPosition } from "../core/IndserObject";
import { DBEntity } from "../CadEngine";

interface DrawOperationMovePointBeforeParams {
  ray: THREE.Ray;
  array: IndserObject[];
  tol: number;
}

interface DrawOperationMovePointParams {
  point: THREE.Vector3;
  geo: any;
  position: IndsertPosition;
  obejct?: DBEntity[] | THREE.Object3D[];
}

interface IModifyOperation {
  /**
   * 过滤相交的元素
   * @param array
   */
  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void;
  OnMovePoint(point: DrawOperationMovePointParams): void;
  OnDownPoint(point: DrawOperationMovePointParams): void;
  onMouseMove(e: PointerEvent): void;
  onMouseUp(e: PointerEvent): void;
  onMouseDown(e: PointerEvent): void;
  onKeyDown(e: KeyboardEvent): void;
  OnZoom(camera: THREE.Camera): void;
  Finish(operate: ModifyOperateState):void
  OnWheel(e: WheelEvent): void;
  onKeyUp(e: KeyboardEvent): void;
}

/**
 * 结束状态
 */
enum ModifyOperateState {
  complete,
  cancel,
}

export {
  IModifyOperation,
  ModifyOperateState,
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
};
